import { render } from "./ThumbnailCaption.vue?vue&type=template&id=e673de8a&scoped=true&ts=true"
import script from "./ThumbnailCaption.vue?vue&type=script&lang=ts"
export * from "./ThumbnailCaption.vue?vue&type=script&lang=ts"

import "./ThumbnailCaption.vue?vue&type=style&index=0&id=e673de8a&scoped=true&lang=scss"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e673de8a"]])

export default __exports__